module.exports = __webpack_public_path__ + "static/media/chargext-5.09e18a1c.jpg";